module.exports = __webpack_public_path__ + "img/21.3e006fe7.jpg";